import {
    GET_BADGES,
    ADD_BADGE,
    UPDATE_BADGE,
    DELETE_BADGE,
  } from "./types";
  
  const initialState = {
    badges      : [],   // list for current page
    totalBadges : 0,    // whole-collection count
  };
  
  const badgeReducer = (state = initialState, action) => {
    switch (action.type) {
      /* ─────────── list / search ─────────── */
      case GET_BADGES:
        return {
          ...state,
          badges     : action.payload.badges,
          totalBadges: action.payload.total,
        };
  
      /* ─────────── create ─────────── */
      case ADD_BADGE:
        return {
          ...state,
          badges     : [action.payload, ...state.badges],
          totalBadges: state.totalBadges + 1,
        };
  
      /* ─────────── update ─────────── */
      case UPDATE_BADGE:
        return {
          ...state,
          badges: state.badges.map(b =>
            b._id === action.payload._id ? action.payload : b
          ),
        };
  
      /* ─────────── delete ─────────── */
      case DELETE_BADGE:
        return {
          ...state,
          badges     : state.badges.filter(b => b._id !== action.payload),
          totalBadges: state.totalBadges - 1,
        };
  
      default:
        return state;
    }
  };
  
  export default badgeReducer;
  
